/**
 * Legacy URL: /sleeve-revision.
 * Permanent redirect to the canonical sleeve revision page
 * (/services/revisions/sleeve). Intentionally excluded from the sitemap
 * (redirect target only).
 */
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/sleeve-revision")({
  beforeLoad: () => {
    throw redirect({ to: "/services/revisions/sleeve", statusCode: 301, replace: true });
  },
});
